import React, { useEffect, useState } from "react";
import { AttributeField } from "../Input/Input";
import { useTranslation } from "react-i18next";
import StandardH3 from "../UI/StandardH3";
import StandardH4 from "../UI/StandardH4";
import StandardH5 from "../UI/StandardH5";
import { googleDataLayer } from "../Analytics/Universal/PageView/googleDataLayer";
import TicketIcon from "../UI/TicketSVG";

const ComboDetails = ({
  config,
  comboProducts,
  isHotelCart,
  passedProps,
  isCro1381,
}) => {
  /* LOADING THE BRANDED SCSS */
  const [styles, setStyles] = useState(false);
  const { t } = useTranslation("common");

  useEffect(() => {
    const getStyles = async (theFileName, theFileEnd) => {
      if (config.brand) {
        let moduleStyles = false;
        try {
          moduleStyles = await import(
            "./" + theFileName + config.brand + theFileEnd
          );
          setStyles(moduleStyles);
        } catch (e) {
          console.error(
            `Styles for ${theFileName} could not be loaded, ${e.message}`
          );
        }
      }
    };
    // Specify file name and end of file name here.
    getStyles("TicketDetails", ".module.scss");
  }, [config.brand]);

  /* END LOADING THE BRANDED SCSS */

  const getTitle = (title) => {
    // Replace <div> and </div> with a delimiter
    const replacedString = title.replace(/<\/?div>/g, "|");

    const titles = replacedString
      .split("|")
      .filter((title) => title.trim() !== "");
    return titles;
  };

  const getFormatForAttributeLabel = (title) => {
    let attributeLabel;
    if (title.includes(":")) {
      attributeLabel = title.split(":")[1];

      if (attributeLabel.includes("Lead Passenger")) {
        const parts = title.split("Lead Passenger").map((part) => part.trim());
        attributeLabel = `${parts[1]} (Lead Passenger)`.trim();
      }
    }
    return attributeLabel;
  };

  const groupTicketsByProductTitle = (data) => {
    const groupedTickets = {};
    const products = Object.keys(data);

    products.forEach((product, productIndex) => {
      const productTitle = getTitle(data[product].title)[0];

      if (!groupedTickets[productTitle]) {
        groupedTickets[productTitle] = {};
      }

      data[product].tickets.forEach((ticket) => {
        ticket.attributes.forEach((attributeGroup, attributeGroupIndex) => {
          attributeGroup.forEach((attribute) => {
            const ticketTitle = getTitle(data[product].title).find((str) =>
              str.includes(attribute.product_title)
            );
            const attributeProductTitle =
              ticketTitle !== "" ? ticketTitle : attribute.product_title;

            if (!groupedTickets[productTitle][attributeProductTitle]) {
              groupedTickets[productTitle][attributeProductTitle] = {};
            }
            const typeKey = `${ticket.type}_${attributeGroupIndex}`;
            if (!groupedTickets[productTitle][attributeProductTitle][typeKey]) {
              groupedTickets[productTitle][attributeProductTitle][typeKey] = [];
            }
            groupedTickets[productTitle][attributeProductTitle][typeKey].push(
              attribute
            );
          });
        });
      });
    });

    return groupedTickets;
  };

  const groupedTickets = groupTicketsByProductTitle(comboProducts);

  let count = 1;
  let previousKey = "";
  return (
    <>
      {Object.getOwnPropertyNames(groupedTickets).map((productTitle,index) => (
        <React.Fragment key={productTitle}>
          <div className={styles.productTitle}>
            <StandardH5 className={`${(!isCro1381 && "fancy")}`} dataTestId='product-title'>
              {productTitle}
            </StandardH5>
          </div>
          <div>
            {Object.getOwnPropertyNames(groupedTickets[productTitle]).map(
              (productName) => (
                <div key={productName}>
                  <div className={styles.cro1381TicketHeader}>
                    <div className={styles.cro1381Icon}>
                      {TicketIcon("#69696b")}
                    </div>
                    <StandardH4 className="ticketTitle" dataTestId='ticket-title'>
                      {productName}
                    </StandardH4>
                  </div>
                  {Object.getOwnPropertyNames(
                    groupedTickets[productTitle][productName]
                  ).map((type, typeIndex) => {
                    const typeTitle = type.toString().split("_")[0];
                    const currentKey = `${productName}_${typeTitle}`;
                    if (currentKey !== previousKey) {
                      count = 1;
                      previousKey = currentKey;
                    } else {
                      count += 1;
                    }
                    return (
                      <>
                        <StandardH3 className={styles.person}>
                          {t(typeTitle)} {count}
                        </StandardH3>
                        <div
                          key={typeIndex}
                          className={
                            isCro1381 &&
                            groupedTickets[productTitle][productName][type]
                              .length > 1
                              ? "cro1381HalfForm"
                              : "cro1381FullForm"
                          }
                        >
                          {groupedTickets[productTitle][productName][type].map(
                            (ticket, ticketIndex) => {
                              return (
                                <React.Fragment
                                  key={ticket.key + "_" + typeIndex}
                                >
                                  <AttributeField
                                    props={passedProps}
                                    att={ticket}
                                    index={typeIndex}
                                    ticket={ticket}
                                    attTitle={ticket.title}
                                    product={ticket.product_title}
                                    fieldTitle={
                                      ticket.type + " " + (typeIndex + 1)
                                    }
                                    maskingClass="gb-mask"
                                    dataLayerInput={() =>
                                      googleDataLayer.createTicketDetailsFieldsEvent(
                                        ticket.title,
                                        productTitle,
                                        ticket.type + " " + (typeIndex + 1)
                                      )
                                    }
                                    isHotelCart={isHotelCart}
                                    label={getFormatForAttributeLabel(
                                      ticket.title
                                    )}
                                  />
                                </React.Fragment>
                              );
                            }
                          )}
                        </div>
                      </>
                    );
                  })}
                </div>
              )
            )}
          </div>
          {(index + 1) !== Object.keys(groupedTickets).length && <hr className={styles.horizontalLine}/>}
        </React.Fragment>
      ))}
    </>
  );
};

export default ComboDetails;
